/* global slideUp, slideDown, attachEvent */
// **************************************************
// Accordion toggle
// **************************************************

attachEvent('.accordion__title', 'click', (ev) => {
  ev.preventDefault();

  const faqItem = ev.target.closest('.accordion__item');

  const closeFaqItems = () => {
    document.querySelectorAll('.accordion__item').forEach((elem) => {
      if (elem.classList.contains('is-open')) {
        elem.classList.remove('is-open');
        slideUp(elem.querySelector('.accordion__content'), 300);
      }
    });
  };

  if (faqItem.classList.contains('is-open')) {
    closeFaqItems();
  } else {
    closeFaqItems();
    faqItem.classList.add('is-open');
    slideDown(faqItem.querySelector('.accordion__content'), 300);
  }
});
